import { Link, useLocation, useParams } from "react-router-dom";
import { CheckCircle2, AlertTriangle, Copy } from "lucide-react";
import { useState } from "react";
import { toast } from "sonner";
import MmpLayout from "./MmpLayout";

export default function MmpSuccess() {
  const { uniqueId } = useParams();
  const { state } = useLocation();
  const [copied, setCopied] = useState(false);

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(uniqueId);
      setCopied(true);
      toast.success("Unique ID copied");
    } catch { /* ignore */ }
  };

  return (
    <MmpLayout>
      <div className="mia-container py-16 max-w-2xl">
        <div className="rounded-2xl border border-emerald-500/30 bg-[#0E1525] p-8 sm:p-10 text-center">
          <div className="mx-auto w-16 h-16 rounded-full bg-emerald-500/15 text-emerald-400 flex items-center justify-center">
            <CheckCircle2 className="w-8 h-8" />
          </div>
          <h1 className="font-display font-black text-2xl sm:text-3xl mt-6">Submission Received Successfully</h1>
          <p className="text-slate-400 mt-2">Your profile has been added to the Marine & Maritime Professional database.</p>

          <div className="mt-8 rounded-xl border border-sky-500/40 bg-sky-500/10 p-5">
            <div className="text-[0.62rem] font-bold tracking-[0.24em] uppercase text-sky-300">Your Unique ID</div>
            <div className="mt-2 font-mono text-2xl sm:text-3xl font-black text-white tracking-[0.08em] select-all" data-testid="mmp-unique-id">{uniqueId}</div>
            <button onClick={copy} className="mt-4 inline-flex items-center gap-2 text-xs font-semibold text-sky-300 hover:text-sky-200" data-testid="mmp-copy-id">
              <Copy className="w-3.5 h-3.5" /> {copied ? "Copied!" : "Copy ID"}
            </button>
          </div>

          <div className="mt-6 rounded-lg border border-amber-500/30 bg-amber-500/10 p-4 text-left text-sm text-amber-200 flex items-start gap-3">
            <AlertTriangle className="w-4 h-4 mt-0.5 shrink-0" />
            <div>
              <div className="font-bold uppercase tracking-wider text-xs">Important — Save Your Unique ID</div>
              <div className="mt-1 text-amber-100/90">Please write down, screenshot, or copy this Unique ID and keep it safe. You will need it to retrieve or update your profile.</div>
            </div>
          </div>

          {state?.email && <div className="text-slate-400 text-sm mt-6">Sent to <span className="text-slate-200">{state.email}</span></div>}

          <div className="mt-8 flex flex-col sm:flex-row gap-3 justify-center">
            <Link to="/careers/retrieve" className="inline-flex items-center justify-center bg-sky-500 hover:bg-sky-400 text-[#0B0F1A] font-bold text-sm uppercase tracking-[0.14em] px-6 py-3 rounded-lg" data-testid="mmp-cta-retrieve">Retrieve / Update Profile</Link>
            <Link to="/" className="inline-flex items-center justify-center border border-white/15 hover:border-sky-400 text-slate-200 font-semibold text-sm px-6 py-3 rounded-lg" data-testid="mmp-cta-home">Back to Home</Link>
          </div>
        </div>
      </div>
    </MmpLayout>
  );
}
